module.exports = __webpack_public_path__ + "static/media/link-grey.5b9a7c8f.svg";